export function highlightWord(word: string, termWord: string) {
  return word.replace(
    new RegExp(termWord, 'gi'),
    (match) => `<span class="v-autocomplete__mask">${match}</span>`
  )
}

export function highlightTerms(
  text: string | undefined,
  term: string | undefined
) {
  if (!term || !text) {
    return text
  }

  const termWords = term.toLowerCase().split(' ')
  const textWords = text.split(' ')

  const result = textWords.map((word) => {
    for (const termWord of termWords) {
      if (word.toLowerCase().includes(termWord)) {
        return highlightWord(word, termWord)
      }
    }
    return word
  })

  return result.join(' ')
}
